import { treeMap } from '@/shared/lib/utils/tree/tree-map';

export const expand = ({ node, setExpandedState, onExpand }) => {
  onExpand?.(node);
  setExpandedState((prev) => ({
    ...prev,
    [node]: true,
  }));
};

export const collapse = ({ node, onExpand, setExpandedState }) => {
  onExpand?.(node);
  setExpandedState((prev) => ({
    ...prev,
    [node]: false,
  }));
};
export const expandRecursive = ({
  node,
  onExpand,
  setExpandedState,
  data,
  valueField,
}) => {
  onExpand?.(node);
  // if (tree.expandedState[node]) return;

  let targetNode: any = null;

  treeMap(data, 'children', (n) => {
    if (valueField(n) === node) {
      targetNode = n;
      return n;
    }
    return n;
  });

  if (!targetNode || !targetNode.children) return;

  const childrenKeys: string[] = [node];
  treeMap(targetNode.children, 'children', (child) => {
    childrenKeys.push(valueField(child));
    return child;
  });

  if (childrenKeys.length > 0) {
    setExpandedState((prev) => ({
      ...prev,

      ...Object.fromEntries(childrenKeys.map((child) => [child, true])),
    }));
  }
};

export const collapseRecursive = ({
  node,
  onExpand,
  expandedState,
  setExpandedState,
  data,
  valueField,
}) => {
  onExpand?.(node);
  if (!expandedState[node]) return;

  let targetNode: any = null;

  treeMap(data, 'children', (n) => {
    if (valueField(n) === node) {
      targetNode = n;
      return n;
    }
    return n;
  });

  if (!targetNode || !targetNode.children) return;

  const childrenKeys: string[] = [];
  treeMap(targetNode.children, 'children', (child) => {
    childrenKeys.push(valueField(child));
    return child;
  });

  setExpandedState((prev) => {
    const newState: typeof prev = {};
    for (const key in prev) {
      if (key !== node && !childrenKeys.includes(key)) {
        newState[key] = prev[key];
      }
    }
    return newState;
  });
};